var _QUEST_ARR={
    "1":{
        menu:{obj:"#mainButtonsBar .iconJS[data-type='map']",arrow:{rotation:180,left:10,top:-70}},
        hideArrowInPages:["map","girlnew","initvideo"]
    },
    "2":{
        menu:{obj:"#mainButtonsBar .iconJS[data-type='girls']",arrow:{rotation:180,left:10,top:-70}},
        pages:{
          "girls/1/":{obj:".cellBig.girlBar .contentNeed .cell[data-type='cash']",arrow:{rotation:90,left:-50,top:-16}},
          "girls":{},
          "cash":{obj:".place.cash>.build.item[g_id='1']",arrow:{rotation:270,right:-20,top:0}}
        },
        hideArrowInPages:["girlnew"]
    },
    "2_book":{
        pages:{
          "cash":{obj:".place.cash>.book[g_id='1'] .myButton",arrow:{rotation:270,right:-40,top:-14}}
        },
    },
    "3":{
        menu:{obj:"#mainButtonsBar .iconJS[data-type='girls']",arrow:{rotation:180,left:10,top:-70}},
        pages:{
          "girls/1/":{obj:"#quickHappyJS",arrow:{rotation:90,left:-50,top:-16}},
          "girls":{},
        },
    },
    "3_book":{
         pages:{
          "girls/1/":{obj:""},
        },
    },
    "4":{
        menu:{obj:"#mainButtonsBar .iconJS[data-type='girls']",arrow:{rotation:180,left:10,top:-70}},
        pages:{
          "girls/1/":{obj:""},
          
        },
    },
    "4_1":{
        menu:{obj:"#mainButtonsBar .iconJS[data-type='girls']",arrow:{rotation:180,left:10,top:-70}},
        pages:{
          "girls/1/":{obj:"#endFilmByPremium,#premiumSpeedUPJS",arrow:{rotation:90,left:-40,top:-12}},
          
        },
    },
    "5":{
        menu:{obj:"#profileBelt #profileContent .myLink[action='mission']",arrow:{rotation:0,left:10,bottom:-70}},
        pages:{
          "mission":{obj:".place.mission .missionJS .row.formXHR .myButton:not(.unable)",arrow:{rotation:90,left:-40,top:10}},
          
        },
    },
    
    
    
    
    "6":{
        menu:{obj:"#mainButtonsBar .iconJS[data-type='girls']",arrow:{rotation:180,left:10,top:-70}},
        pages:{
            "girls/1/":{obj:""},
        },
        hideArrowInPages:["girlnew"]
    },
    "6_happy":{
        menu:{obj:"#mainButtonsBar .iconJS[data-type='girls']",arrow:{rotation:180,left:10,top:-70}},
        pages:{
          "girls/1/":{obj:"#quickHappyJS",arrow:{rotation:90,left:-50,top:-16}},
        },
    },
    "6_startSkill":{
        menu:{obj:"#mainButtonsBar .iconJS[data-type='girls']",arrow:{rotation:180,left:10,top:-70}},
        pages:{
            "girls/1/":{obj:".cellBig.girlBar .contentNeed .cell[data-type='skill']",arrow:{rotation:90,left:-50,top:-16}},
            "skills":{obj:".place.skills>.item[g_id='1']",arrow:{rotation:270,right:-20,top:40}}
        },
        hideArrowInPages:["girlnew"]
    },
    "6_book":{
        pages:{
          "skills":{obj:".place.skills>.book[g_id='1'] .myButton",arrow:{rotation:270,right:-40,top:-14}},
          "girls/1/":{obj:""}
        },
    },
    
    
    
    
    
    
    
    
    
    "8_need":{
        menu:{obj:"#mainButtonsBar .iconJS[data-type='girls']",arrow:{rotation:180,left:10,top:-70}},
        pages:{
          "girls/1/":{obj:".cellBig.girlBar .contentNeed .cell[data-type='skill'][data-type_id='2']",arrow:{rotation:90,left:-50,top:-16}},
          "skills":{obj:".place.skills .skillTimerJS .skillJS[data-id='2'] .myImage.play",arrow:{rotation:90,left:-60,top:-18}},
          "explainenergy":{obj:".place.explainenergy #questTriggerSkillEE",arrow:{rotation:90,left:-60,top:-18}},
        },
        hideArrowInPages:["girlnew"]
    },
    "8_need_book":{
        menu:{obj:"#mainButtonsBar .iconJS[data-type='girls']",arrow:{rotation:180,left:10,top:-70}},
        pages:{
          "skills":{obj:".place.skills .book.skill[g_id='2'] .myButton",arrow:{rotation:90,left:-60,top:-18}},
        }
    },
    "8_need_before":{
        menu:{obj:"#mainButtonsBar .iconJS[data-type='girls']",arrow:{rotation:180,left:10,top:-70}},
        pages:{
          "girls/1/":{obj:".cellBig.girlBar .contentNeed .cell[data-type='skill'][data-type_id='2']",arrow:{rotation:90,left:-50,top:-16}},
          "skills":{obj:".place.skills .skillTimerJS .skillJS[data-id='2'] .myImage.play",arrow:{rotation:90,left:-60,top:-18}},
          "explainenergy":{obj:".place.explainenergy #questTriggerSkillEE",arrow:{rotation:90,left:-60,top:-18}},
        },
        hideArrowInPages:["girlnew"]
    },
    "8_need_before_book":{
        menu:{obj:"#mainButtonsBar .iconJS[data-type='girls']",arrow:{rotation:180,left:10,top:-70}},
        pages:{
          "skills":{obj:".place.skills .book.skill[g_id='2'] .myButton",arrow:{rotation:90,left:-60,top:-18}},
        }
    },
    "8_stop_skill":{
        menu:{obj:"#mainButtonsBar .iconJS[data-type='skills']",arrow:{rotation:180,left:10,top:-70}},
        pages:{
          "skills":{obj:".place.skills .skillTimerJS .skillJS[data-id='1'] .myImage.pause",arrow:{rotation:90,left:-60,top:-18}},
          "explainenergy":{obj:".place.explainenergy #questTriggerSkillEE",arrow:{rotation:90,left:-60,top:-18}},
        },
        hideArrowInPages:["girlnew"]
    },
    "8_stop_skill_book":{
        menu:{obj:"#mainButtonsBar .iconJS[data-type='girls']",arrow:{rotation:180,left:10,top:-70}},
        pages:{
          "skills":{obj:".place.skills .book.skill[g_id='1'] .myButton",arrow:{rotation:90,left:-60,top:-18}},
        }
    },
    "8_stop_cash":{
        menu:{obj:"#mainButtonsBar .iconJS[data-type='cash']",arrow:{rotation:180,left:10,top:-70}},
        pages:{
          "cash":{obj:".place.cash .cashContJS .skillJS[data-id] .myImage.pause:eq(0)",arrow:{rotation:90,left:-60,top:-18}},
          "explainenergy":{obj:".place.explainenergy #questTriggerCashEE",arrow:{rotation:90,left:-60,top:-18}},
        },
    },
    "8_wait":{
        menu:{obj:"#mainButtonsBar .iconJS[data-type='girls']",arrow:{rotation:180,left:10,top:-70}},
        pages:{
           "girls/1/":{obj:""}
        },
        hideArrowInPages:["girlnew"]
    },
    "11_guest":{
        menu:{obj:"#mainEmailConf[data-type='guestconfirm']",arrow:{rotation:180,left:100,top:-80}},
        pages:{
           "guestconfirm":{obj:""}
        },
    },
    "11_skill":{
        menu:{obj:"#mainButtonsBar .iconJS[data-type='skills']",arrow:{rotation:180,left:10,top:-70}},
        pages:{
          "skills":{obj:".place.skills .skillTimerJS .skillJS[data-id='1'] .myImage.play,.place.skills .skillTimerJS .skillJS[data-id='2'] .myImage.play",arrow:{rotation:90,left:-60,top:-18}}
        },
    },
    "11_need_energy":{
        menu:{obj:"#mainButtonsBar .iconJS[data-type='cash']",arrow:{rotation:180,left:10,top:-70}},
        pages:{
          "cash":{obj:".place.cash .cashContJS .skillJS[data-id] .myImage.pause:eq(0)",arrow:{rotation:90,left:-60,top:-18}},
          "explainenergy":{obj:".place.explainenergy #questTriggerCashEE",arrow:{rotation:90,left:-60,top:-18}},
        },
    },
    "11_skip":{
        
        menu:{obj:"#mainButtonsBar .iconJS[data-type='premiumshop']",arrow:{rotation:180,left:10,top:-70}},
        pages:{
          "premiumshop":{obj:".place.premiumshop #chooseTabCont .chooseTab[data-type='skip']",arrow:{rotation:180,left:90,top:-18}},
          "premiumtime/1/":{obj:".place.premiumtime .cellWrap[data-type_id='1'] .myButton",arrow:{rotation:90,left:-60,top:-18}},
        },
    },
    "11_cash":{
        
        menu:{obj:"#mainButtonsBar .iconJS[data-type='cash']",arrow:{rotation:180,left:10,top:-70}},
        pages:{
          "cash":{obj:".place.cash .cashContJS .myImage.play:not(.unable):eq(0)",arrow:{rotation:90,left:-60,top:-18}},
        },
    },
    "11_collect_energy":{
        menu:{obj:"#profileBelt #profileContent .myLink[action='mission']",arrow:{rotation:0,left:10,bottom:-70}},
        pages:{
          "mission":{obj:".place.mission .missionJS .row.formXHR .myButton:not(.unable)",arrow:{rotation:90,left:-40,top:10}},
          
        },
    },
    "21":{
        menu:{obj:"#profileBelt #beltTime",arrow:{rotation:0,left:40,bottom:-70}},
        pages:{
          "explainbonus":{obj:".place.explainbonus #explainJsNormal",arrow:{rotation:90,left:-40,top:80}},
          "premiumreset":{obj:".place.premiumreset #premiumJsNormalReset",arrow:{rotation:180,left:85,top:-80}},
        },
    },
    "-100":{}
    
    
},
//rotate:left,right,top
//one can add field top,left to object     
_questTimeHandler=new timeHandler(),
_QUEST_ARROW_INDEX=_questTimeHandler.getNewIndex(),_QUEST_ARROW_INDEX2=_questTimeHandler.getNewIndex();
var _QUEST_VALS={};
var _QUEST_TEXT='';
var _questHandle={
    "6":function(vars){
        if(!_SkillSet.objSet[1].isWorking() && _SkillSet.objSet[1].getLevel()<2){
            return {"vars":"startSkill"};
        }
        return {"vars":"in_girls"};
        
        //
//        return {"vars":""};
    },
    "8":function(vars){
        if(_SkillSet.objSet[1].getLevel()>=3){
            if(_SkillSet.objSet[2].isWorking()){
                return {"vars":"wait"};
            }
            if(vars==1){
                if(_SkillSet.objSet[1].isWorking()){
                    return {"vars":"stop_skill"};
                }
                else if(_myProfile.takeData("energy")>=5){
                    return {"vars":"need"};
                }
                else{
                    return {"vars":"stop_cash"};
                }
            }
            else{
                return {"vars":"need_before"};
            }
            
        }
    },
    "11":function(vars){
        if(_isGuest){
            return {"vars":"guest"};
        }
        if(_myProfile.takeData("mission_flag")){
            return {"vars":"collect_energy"};
        }
        if(!_SkillSet.objSet[1].isWorking() || !_SkillSet.objSet[2].isWorking()){
            var need_energy=0;
            if(!_SkillSet.objSet[1].isWorking()){
                need_energy+=_SkillSet.objSet[1].user.energy;
            }
            if(!_SkillSet.objSet[2].isWorking()){
                need_energy+=_SkillSet.objSet[2].user.energy;
            }
            if(vars==0){
                return {"vars":"skill"};
            }
            if(_myProfile.takeData("energy")>=need_energy){
                return {"vars":"skill"};
            }
            else{
                return {"vars":"need_energy"};
            }
        }
        else{
            var canSetCash=0,i,obj,haveEnergy=_myProfile.takeData("energy");
            for(i in _cashObjSet.objSet){
                obj=_cashObjSet.objSet[i];
                if(obj.isOwn() && !obj.isWorking() && obj.user.energy<=haveEnergy){
                    canSetCash=1;
                }
            }
            if(canSetCash==0){
                return {"vars":"skip"};
            }
            else{
                return {"vars":"cash"};
            }
            
        }
    },
};
function prepareQuestVars(q_id,vars){
    var obj;
    if(typeof _questHandle[q_id+"_"+vars]!="undefined"){
        obj=_questHandle[q_id+"_"+vars](vars);
    }
    else if(typeof _questHandle[q_id]!="undefined"){
        obj=_questHandle[q_id](vars);
    }
    return obj;
}
function prepareQuest(q_id,vars,text){
    if(q_id){
        _QUEST_VALS={q_id:q_id,vars:vars};
    }
    else{
        q_id=_QUEST_VALS.q_id;
        if(!vars){
            vars=_QUEST_VALS.vars;
        }
    }
    
    
    if(q_id>0 && vars==_QUEST_VALS.vars){
        var obj=prepareQuestVars(q_id,vars);
        if(typeof obj!="undefined"){
            if(typeof obj.vars!="undefined"){
                vars=obj.vars;
            }
        }
    }
    
    
    var quest_use=getQuestConfig(q_id,vars);
    
    var tutHandle=$(".tutorialHandle").addClass("hide");
    if(quest_use){
        tutHandle.filter("[data-vars='"+quest_use.obj_key+"']").removeClass("hide");
        
        _questTimeHandler.clear(_QUEST_ARROW_INDEX);
        _questTimeHandler.clear(_QUEST_ARROW_INDEX2);
        $(".tutorialArrow").remove();
        
        if(typeof quest_use.obj!="undefined" && quest_use.obj!=""){
            var main_obj=$(quest_use.obj);
            main_obj.append("<div class='arrowView tutorialArrow'></div>").
            find(".arrowView.tutorialArrow").myUpDown(
                $.extend(quest_use.arrow,{timeHandlerIndex:_QUEST_ARROW_INDEX})
                ,_questTimeHandler
            );
            var to_click_step=0;
            _questTimeHandler.set(_QUEST_ARROW_INDEX2,function(){
                to_click_step=(to_click_step+1)%2;
                if(to_click_step){
                    main_obj.addClass("qblink");
                }
                else{
                    main_obj.removeClass("qblink");
                }
            },500,function(){
                //on clear!!
                main_obj.removeClass("qblink");
            });
        }
    }
    
    $.tutorialTextFit();
    
    if (q_id == -1)  {
        //tutorial end!!!
        return false;
    } else {
        
        questEvent(q_id,vars);
    }
    return true;
}
function getQuestConfig(q_id,vars){
    if(!q_id){
        q_id=_QUEST_VALS.q_id;
    }
    if(!vars){
        vars=_QUEST_VALS.vars;
    }
    var quest=false,quest_use=false,cur_page=getCurrentPage(),tmp;
    var obj_key="";
    if(typeof _QUEST_ARR[q_id+"_"+vars]!="undefined"){
        quest=_QUEST_ARR[q_id+"_"+vars];
        obj_key=q_id+"_"+vars;
    }
    else if(typeof _QUEST_ARR[q_id]!="undefined"){
        quest=_QUEST_ARR[q_id];
        obj_key=q_id;
    }
    
    
    
    if(quest){

        if(typeof quest.pages!="undefined"){
            var check_conf={
                "1":getCurrentPopup(1),
                "2":getCurrentPage(1),
                "3":getCurrentPopup(),
                "4":getCurrentPage(),
            };
            if(check_conf["1"]==check_conf["3"]){
                delete check_conf["1"];
            }
            if(check_conf["2"]==check_conf["4"]){
                delete check_conf["2"];
            }
            
            var i,bum;
            for(i in check_conf){
                bum=check_conf[i];
                if(typeof quest.pages[bum]!="undefined"){
                    quest_use=copyObj(quest.pages[bum]);
                    break;
                }
            }
        }
        if(!quest_use && typeof quest.menu!="undefined"){
            quest_use=copyObj(quest.menu);
        }
        if(typeof quest.hideArrowInPages != "undefined" && quest.hideArrowInPages.length>0){
            if(in_array(cur_page,quest.hideArrowInPages)){
                quest_use.obj="";
            }
        }
    }
    quest_use.obj_key=obj_key;
    return quest_use;
    
}
function isBookQuestArrow(){
    if($(".place>.book:visible .insertQuestArrow:visible").length){
        return true;
    }
    var config= getQuestConfig();
    if(config && typeof config.obj!="undefined" && $(config.obj).closest(".book:visible").length){
        return true;
    }
    return false;
}
function hideQuest(){
    _questTimeHandler.clear(_QUEST_ARROW_INDEX);
    _questTimeHandler.clear(_QUEST_ARROW_INDEX2);
    $("#questArrow").remove();
}
function showQuest(){
    prepareQuest();
}
function updateQuest(){
    prepareQuest(0);
}
function getQuestId(){
    return _QUEST_VALS.q_id;
}
function getQuestVars(from_base){
    var q_id=_QUEST_VALS.q_id,vars= _QUEST_VALS.vars;
    if(from_base){
        return vars;
    }
    var obj=prepareQuestVars(q_id,vars);
    if(typeof obj.vars!="undefined"){
        return obj.vars;
    }
    return vars;
}
function questEvent(q_id,vars){
    var obj={
       "1":function(){
          		
       },
       "23":function(){
           
       }
   };
   if(typeof obj[q_id+"_"+vars]!=="undefined"){
       obj[q_id+"_"+vars].apply();
   }
   else if(typeof obj[q_id]!=="undefined"){
       obj[q_id].apply();
   }
}